import http from '../api/httpRequest.js'

export default {
	state: {
		groups: [],
		activeGroup: {}
	},
	mutations: {
		setGroups(state, groups) {
			state.groups = groups;
			
			// 同步到 Roo-Code 扩展
			try {
				if (window.vscodeServices?.get('ICommandService')) {
					const friends = this.state.friendStore?.friends || [];
					const userInfo = this.state.userStore?.userInfo;
					const userId = userInfo?.id ? String(userInfo.id) : null;
					
					if (userId) {
						window.vscodeServices.get('ICommandService').executeCommand('roo-cline.updateImContacts', {
							userId: userId,
							friends: friends,
							groups: state.groups
						}).catch(err => console.warn('Failed to sync groups to Roo-Code:', err));
					}
				}
			} catch (error) {
				console.warn('VSCode ICommandService not available for syncing groups:', error);
			}
		},
		addGroup(state, group) {
			if (state.groups.some((g) => g.id == group.id)) {
				this.commit("updateGroup", group)
			} else {
				state.groups.unshift(group);
			}
			
			// 同步到 Roo-Code 扩展
			try {
				if (window.vscodeServices?.get('ICommandService')) {
					const friends = this.state.friendStore?.friends || [];
					const userInfo = this.state.userStore?.userInfo;
					const userId = userInfo?.id ? String(userInfo.id) : null;
					
					if (userId) {
						window.vscodeServices.get('ICommandService').executeCommand('roo-cline.updateImContacts', {
							userId: userId,
							friends: friends,
							groups: state.groups
						}).catch(err => console.warn('Failed to sync groups to Roo-Code:', err));
					}
				}
			} catch (error) {
				console.warn('VSCode ICommandService not available for syncing groups:', error);
			}
		},
		removeGroup(state, id) {
			state.groups.filter(g => g.id == id).forEach(g => g.quit = true);
			
			// 同步到 Roo-Code 扩展
			try {
				if (window.vscodeServices?.get('ICommandService')) {
					const friends = this.state.friendStore?.friends || [];
					const userInfo = this.state.userStore?.userInfo;
					const userId = userInfo?.id ? String(userInfo.id) : null;
					
					if (userId) {
						window.vscodeServices.get('ICommandService').executeCommand('roo-cline.updateImContacts', {
							userId: userId,
							friends: friends,
							groups: state.groups
						}).catch(err => console.warn('Failed to sync groups to Roo-Code:', err));
					}
				}
			} catch (error) {
				console.warn('VSCode ICommandService not available for syncing groups:', error);
			}
		},
		updateGroup(state, group) {
			state.groups.forEach((g, idx) => {
				if (g.id == group.id) {
					// 拷贝属性
					Object.assign(state.groups[idx], group);
				}
			})
			
			// 同步到 Roo-Code 扩展
			try {
				if (window.vscodeServices?.get('ICommandService')) {
					const friends = this.state.friendStore?.friends || [];
					const userInfo = this.state.userStore?.userInfo;
					const userId = userInfo?.id ? String(userInfo.id) : null;
					
					if (userId) {
						window.vscodeServices.get('ICommandService').executeCommand('roo-cline.updateImContacts', {
							userId: userId,
							friends: friends,
							groups: state.groups
						}).catch(err => console.warn('Failed to sync groups to Roo-Code:', err));
					}
				}
			} catch (error) {
				console.warn('VSCode ICommandService not available for syncing groups:', error);
			}
		},
		clear(state) {
			state.groups = [];
		},
		setActiveGroup(state, group) {
			state.activeGroup = group;
		}
	},
	actions: {
		loadGroup(context) {
			return new Promise((resolve, reject) => {
				http({
					url: '/group/list',
					method: 'GET'
				}).then((groups) => {
					context.commit("setGroups", groups);
					resolve();
				}).catch((res) => {
					reject(res);
				})
			});
		}
	},
	getters: {
		findGroup: (state) => (id) => {
			return state.groups.find((g) => g.id == id);
		}
	}
}